import CourseController from '../diagrams/course.controller';

class ScqDiagramCourseController extends CourseController {

  constructor(courseService, diagramService, $translate, $timeout, $scope) {
    'ngInject';

    super(courseService, diagramService, $translate, $scope);

    this.$timeout = $timeout;
    this.showSchoolAnswer = {
      0: true,
      1: true,
      2: true
    }

  }

  $postLink() {
    this.diagramId = this.data.id;
    this.hideTaskTitle = this.data.hideTaskTitle;
  }

  showUserAnswear(block) {
    if (this.diagramComplete) {
      block.model = block.userAnswer;
    }
  }

  hideUserAnswear(block) {
    if (this.diagramComplete) {
      block.model = block.answer;
    }
  }

  submit() {
    this.courseService.play('buttonClick');
    if (this.hideTaskTitle) {
      this.hideTaskTitle = false;
    } else {
      let time = 500;
      for (let block of this.data.blocks) {
        block.userAnswer = block.model;
        this.$timeout(() => block.model = block.answer, time);
        time += 500;
      }
    }
    this.finishExercise();
    this.diagramComplete = true;
  }

  // switch() {
  //   this.courseService.play('buttonClick');
  //   this.showSchoolAnswer = !this.showSchoolAnswer;
  //   this.diagramComplete = true;
  // }

  showUserAnswers() {

  }

  isNeedToShowTaskTitle() {
    return this.showTaskTitle;
  }

}

export default ScqDiagramCourseController;



// WEBPACK FOOTER //
// ./client/app/components/diagrams/scq-diagram-course.controller.js